import styled from 'styled-components';

import S from '../UI/variables';

export const StyledProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 18px 6px;
  width: fit-content;
  border-radius: 5px;
  background: #fff;
  box-shadow: ${S.recentsCardShade};
  & form {
    padding: 0;
    & > h2 {
      display: none;
    }
  }
  @media screen and (min-width: ${S.tablet}) {
    flex-direction: row;
    padding: 24px 74px 6px 24px;
    & form {
      padding-left: 32px;
    }
  }
  margin-bottom: 30px;
`;

export const StyledAvatarWrapper = styled.div`
  width: 105px;
  height: 120px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  margin-bottom: 24px;
  &:after {
    content: 'Pridėti nuotrauką';
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;
    height: 34px;
    background: ${S.accentBlue};
    color: #fff;
    font-size: 12px;
    font-weight: 300;
    line-height: 34px;
    text-align: center;
    transition: transform ${S.trFast};
    cursor: pointer;
    opacity: 0.7;
  }
  &:hover:after {
    transform: translateY(0);
  }
  & img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
  @media screen and (min-width: ${S.tablet}) {
    margin-bottom: 0;
    width: 140px;
    height: 160px;
    &:after {
      transform: translateY(100%);
      opacity: 1;
    }
  }
`;

export const StyledControlsWrapper = styled.ul`
  display: flex;
  & > li:not(:last-child) {
    margin-right: 20px;
  }
  margin-bottom: 24px;
  @media screen and (min-width: ${S.tablet}) {
    position: absolute;
    right: 20px;
    top: 40px;
    margin-bottom: 0;
  }
`;
